import { useState } from "react";
import { UnitSizeRead } from "@types";
import { useAssignCategoryToSizes } from "@api";

export function useManageUnitSizes() {
  const [selectedUnitSize, setSelectedUnitSize] = useState<UnitSizeRead | null>(
    null,
  );
  const [isSideBarOpen, setIsSideBarOpen] = useState<boolean>(false);
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
  const [unitSizeToDeleteId, setUnitSizeToDeleteId] = useState<string>("");
  const [selectedSizes, setSelectedSizes] = useState<UnitSizeRead[]>([]);
  const [selectedCategory, setSelectedCategory] = useState<string | null>(null);

  const { triggerAssignCategory } = useAssignCategoryToSizes();

  const handleAssignCategory = async () => {
    if (!selectedCategory || selectedSizes.length === 0) return;
    await triggerAssignCategory({
      sizeIds: selectedSizes.map((s) => s.id!),
      unitCategoryId: selectedCategory,
    });
    setSelectedSizes([]);
    setSelectedCategory(null);
  };

  const toggleSideBar = () => {
    setSelectedUnitSize(null);
    setIsSideBarOpen((prev) => !prev);
  };

  const selectSizeToEdit = (Size: UnitSizeRead) => {
    setIsSideBarOpen(true);
    setSelectedUnitSize(Size);
  };

  const handleCloseDetailsModal = () => {
    setIsDetailsModalOpen(false);
    setSelectedUnitSize(null);
  };

  const handleRowClick = (rowData: { data: UnitSizeRead }) => {
    setSelectedUnitSize(rowData.data);
    setIsDetailsModalOpen(true);
  };

  const handlePressDeleteButton = (id: string) => {
    setUnitSizeToDeleteId(id);
  };

  const handleCloseDeleteDialog = () => {
    setUnitSizeToDeleteId("");
  };

  return {
    selectedUnitSize,
    isSideBarOpen,
    isDetailsModalOpen,
    unitSizeToDeleteId,
    selectedSizes,
    selectedCategory,

    setSelectedUnitSize,
    toggleSideBar,
    selectSizeToEdit,
    handleRowClick,
    handleCloseDetailsModal,
    handlePressDeleteButton,
    handleCloseDeleteDialog,
    setSelectedSizes,
    setSelectedCategory,
    handleAssignCategory,
  };
}
